<div class="modal-overlay" (click)="onOverlayClick()">
  <div class="app-download-modal" (click)="$event.stopPropagation()">

    <button class="close-btn" (click)="close.emit()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>

    <div class="modal-header">
      <h3>Get the iArista CRM App</h3>
      <p>Scan the QR code or tap a button below to download</p>
    </div>

    <div class="qr-slot">
      <img src="assets/images/app-download-qr.png" alt="Scan to download iArista app" />
    </div>

    <div class="store-buttons">
      <a *ngIf="iosUrl" [href]="iosUrl" target="_blank" rel="noopener" class="store-btn store-btn--ios">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
        </svg>
        App Store
      </a>

      <a *ngIf="androidUrl" [href]="androidUrl" target="_blank" rel="noopener" class="store-btn store-btn--android">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.18 23.76c.3.17.65.19.97.07l12.54-7.25-2.88-2.88-10.63 10.06zM.5 1.1C.19 1.43 0 1.95 0 2.62v18.76c0 .67.19 1.19.51 1.52l.08.08 10.51-10.51v-.25L.58 1.02.5 1.1zM20.65 10.5l-2.82-1.63-3.19 3.19 3.19 3.18 2.85-1.65c.81-.47.81-1.23-.03-1.69zM4.15.24L16.69 7.49l-2.88 2.88L3.18.31c.32-.13.68-.11.97.07-.01 0 0-.14 0-.14z"/>
        </svg>
        Play Store
      </a>
    </div>

  </div>
</div>
